import { useLang } from "../../lib/LanguageContext";

const LanguageSwitcher = () => {
  const { lang, switchLang } = useLang();

  return (
    <div className="flex items-center gap-1 bg-surface-highlight rounded-full p-0.5 border border-border" data-testid="language-switcher">
      <button
        onClick={() => switchLang('hr')}
        className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${
          lang === 'hr' ? 'bg-primary text-white' : 'text-text-secondary hover:text-white'
        }`}
        data-testid="lang-hr"
      >
        HR
      </button>
      <button
        onClick={() => switchLang('en')}
        className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${
          lang === 'en' ? 'bg-primary text-white' : 'text-text-secondary hover:text-white'
        }`}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
